<script>
export default {
  name: 'UlLoad',
};
</script>
<template>
  <div class="ul-load">
    <svg viewBox="25 25 50 50" class="ul-load__spinner">
      <circle cx="50" cy="50" r="20" fill="none" class="ul-load__path"></circle>
    </svg>
  </div>
</template>
<style lang="scss">
  .ul-load {
    background-color: rgba(255, 255, 255, 0.9);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    margin: 0;
    transition: opacity 0.3s;

    &__bg {
      width: 100%;
      height: 100%;
    }

    &__spinner {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 42px;
      text-align: center;
      position: absolute;
      animation: ul-load-rotate 2s linear infinite;
    }

    .ul-load__path {
      animation: ul-load-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #334150;
      stroke-linecap: round;
    }
  }

  @keyframes ul-load-rotate {
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes ul-load-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120px;
    }
  }
</style>
